"use client";

import Image from "next/image";

const objectives = [
  "Learning Outcome-Based Education and Assessment",
  "The goal of learning is the achievement of the program/curriculum goals",
  "Assessment methods and its questions must be mapped to each Course Level Outcome (CLO) and every CLO must be mapped to a Program Level Outcome (PLO).",
  "Written: Quizzes, Assignments, Report Writing, etc.",
  "Oral: Viva, Group Discussions, etc.",
  "Practical: Lab Work, Co-Curricular Activities, On-Job Training, etc.",
  "Integrated Mode: Presentations, Field Assignments, Case Studies, Projects, etc.",
];

export default function Evaluation() {
  return (
    <section className="bg-[#081E2D] py-8 md:py-16">
      <div className="page-container mx-auto">
        {/* Header Section */}
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Evaluation
          </h2>
          <p className="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed max-w-5xl">
            Evaluation at Medhavi Skills University is continuous and
            outcome-driven, evaluating Teaching and Course Learning Outcomes
            (TLOs and CLOs) through assignments, quizzes, case studies,
            projects, presentations, digital evaluations, and skill challenges.
            This diverse approach supports both conceptual and applied learning,
            promotes equity, and encourages critical thinking and practical
            skill development.
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-white grid grid-cols-1 lg:grid-cols-2 overflow-hidden">
          {/* Left Content */}
          <div className="p-4 md:p-8 lg:p-10 flex flex-col justify-center">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-8 leading-relaxed">
              Our assessment approach moves away from memorisation-heavy,
              exam-driven evaluation and focuses on understanding, application,
              and innovation in learning. We consciously respond to systemic
              gaps in traditional education. We have the following Primary
              Objectives:
            </h3>

            <ul className="space-y-4">
              {objectives.map((objective, index) => (
                <li key={index} className="flex items-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    className="shrink-0 mt-1"
                  >
                    <rect width="18" height="18" rx="9" fill="#002033" />
                    <path
                      d="M12.9053 7.07067L12.5527 6.71005C12.4074 6.56149 12.1703 6.56149 12.0237 6.71005L8.32602 10.4927L6.389 8.51187C6.24373 8.3633 6.00656 8.3633 5.86004 8.51187L5.50739 8.87249C5.36212 9.02106 5.36212 9.26358 5.50739 9.41341L8.0603 12.0241C8.13357 12.099 8.22792 12.1371 8.32354 12.1371C8.41915 12.1371 8.51475 12.099 8.58679 12.0241L12.9016 7.61161C13.0506 7.46051 13.0506 7.21926 12.9053 7.07067Z"
                      fill="white"
                    />
                  </svg>
                  <p className="text-sm md:text-base text-gray-800 font-medium">
                    {objective}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Image */}
          <div className="relative h-64 lg:h-auto min-h-[400px]">
            <Image
              src="https://cdn.msu.edu.in/school_of_health_science_and_technology_students_af7ff3ca2c.jpg" // Using an existing relevant image
              alt="Student in practical evaluation"
              fill
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
